if (!customElements.get('product-text-toggle')) {
 customElements.define('product-text-toggle', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   this.content = this.querySelector('.product-text-toggle__content');
   this.button = this.querySelector('button');
   if (!this.content || !this.button) return;
   this.expanded = false;
   this.button.addEventListener('click', () => {
    this.expanded = !this.expanded;
    this.update();
   }, { signal: this.controller.signal });
   this.observer = new ResizeObserver(() => this.update());
   this.observer.observe(this.content);
   this.mutations = new MutationObserver(() => this.update());
   this.mutations.observe(this.content, { childList: true, subtree: true, characterData: true });
   document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
   this.update();
  }
  update() {
   const style = getComputedStyle(this.content.firstElementChild || this.content);
   const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
   const limit = lineHeight * (Number(this.dataset.lines) || 3);
   this.style.setProperty('--product-text-height', `${limit}px`);
   const overflowing = this.content.scrollHeight > limit + 1;
   this.button.hidden = !overflowing;
   this.toggleAttribute('data-collapsed', overflowing && !this.expanded);
   this.button.setAttribute('aria-expanded', String(this.expanded));
   this.button.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
  }
  disconnectedCallback() {
   this.controller?.abort(); this.controller = null;
   this.observer?.disconnect(); this.mutations?.disconnect();
  }
 });
}
